module.exports = __webpack_public_path__ + "static/media/3-01.71dbaa75.png";